<template>
  <div>
    <h1>Создание поля</h1>
    <v-row>
      <v-col>
        <field-group-form @onSubmit="store"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import FieldGroupForm from "../../../components/fieldGroups/FieldGroupForm";
export default {
  name: "Create",
  components: {FieldGroupForm},
  methods: {
    ...mapActions({
      storeItem: "FieldGroups/storeItem",
    }),
    store(payload) {
      this.storeItem({ payload: payload, router: this.$router });
    }
  }
}
</script>

<style scoped>

</style>
